import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { RectangleCard } from '../../components';
import { PATHS } from '../../navigation/data';

export const HomeScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="width-100 flex-center-center-column-nowrap">
      <div className="page flex-center-center-column-nowrap">
        <div className="flex-center-center-row-wrap gap-12">
          <RectangleCard label={t('TABS.SALES')} onPress={() => navigate(PATHS.SALES)} />
          <RectangleCard label={t('TABS.CUSTOMERS')} onPress={() => navigate(PATHS.CUSTOMERS)} />
          <RectangleCard label={t('TABS.PRODUCTS')} onPress={() => navigate(PATHS.PRODUCTS)} />
          <RectangleCard label={t('TABS.REPORTS')} onPress={() => navigate(PATHS.REPORTS)} />
          <RectangleCard label={t('TABS.DELIVERIES')} onPress={() => navigate(`${PATHS.DELIVERIES}/create`)} />
          <RectangleCard label={t('TABS.SETTINGS')} onPress={() => navigate(PATHS.SETTINGS)} />
        </div>
      </div>
    </div>
  );
};
